/* Hello Vintage – cart drawer, add-to-cart, product gallery, calendar filter */
(function () {
  if (window.HV && window.HV.ready) return;
  var HV = (window.HV = window.HV || {});
  HV.ready = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function formatMoney(cents) {
    var fmt = HV.moneyFormat || '{{amount_with_comma_separator}} kr.';
    var n = (cents / 100);
    function sep(x, dec, thou, decimals) {
      var parts = x.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(dec);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return sep(n, ',', '.', 0);
        case 'amount_with_comma_separator': return sep(n, ',', '.', 2);
        case 'amount_no_decimals_with_comma_separator': return sep(n, ',', '.', 0);
        case 'amount_with_period_and_space_separator': return sep(n, '.', ' ', 2);
        default: return sep(n, '.', ',', 2);
      }
    });
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Cart drawer ---------- */
  function drawer() { return document.querySelector('[data-hv-drawer]'); }

  function setCount(n) {
    document.querySelectorAll('[data-hv-cart-count]').forEach(function (el) { el.textContent = n; });
  }

  function renderCart(cart) {
    var d = drawer();
    setCount(cart.item_count);
    if (!d) return;
    var items = d.querySelector('[data-hv-items]');
    var foot = d.querySelector('[data-hv-foot]');
    var empty = d.querySelector('[data-hv-empty]');
    items.querySelectorAll('.hv-line').forEach(function (el) { el.remove(); });
    empty.hidden = cart.item_count > 0;
    foot.hidden = cart.item_count === 0;
    cart.items.forEach(function (item) {
      var img = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
      var sub = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      var title = String(item.product_title).split(/\s*[(\-–,]\s*(?:Str\.|str\.|Tilstand)/)[0].replace(/^[\d'’\s\-–s]+(?:erne)?,?\s*/, '') || item.product_title;
      var line = document.createElement('div');
      line.className = 'hv-line';
      line.innerHTML =
        '<a href="' + esc(item.url) + '" class="hv-line__img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div><div class="hv-line__title">' + esc(title) + '</div>' +
        (sub ? '<div class="hv-line__sub">' + esc(sub) + (item.quantity > 1 ? ' · ' + item.quantity + ' stk.' : '') + '</div>' : (item.quantity > 1 ? '<div class="hv-line__sub">' + item.quantity + ' stk.</div>' : '')) +
        '<button type="button" class="hv-line__remove" data-hv-remove="' + esc(item.key) + '">Fjern</button></div>' +
        '<span class="hv-line__price">' + formatMoney(item.final_line_price) + '</span>';
      items.appendChild(line);
    });
    var threshold = parseInt(d.getAttribute('data-free-shipping') || '0', 10);
    var ship = d.querySelector('[data-hv-shipping]');
    if (ship) ship.textContent = threshold && cart.total_price >= threshold ? 'Fri fragt' : 'Beregnes ved betaling';
    var total = d.querySelector('[data-hv-total]');
    if (total) total.textContent = formatMoney(cart.total_price);
  }

  function refreshCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function openDrawer() {
    var d = drawer();
    if (!d) { window.location.href = root + 'cart'; return; }
    d.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    refreshCart();
    var close = d.querySelector('.hv-drawer__close');
    if (close) close.focus();
  }

  function closeDrawer() {
    var d = drawer();
    if (!d) return;
    d.hidden = true;
    document.documentElement.style.overflow = '';
  }

  HV.openCart = openDrawer;

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-hv-cart-open]')) { e.preventDefault(); openDrawer(); return; }
    if (t.closest('[data-hv-cart-close]')) { e.preventDefault(); closeDrawer(); return; }
    var rm = t.closest('[data-hv-remove]');
    if (rm) {
      rm.disabled = true;
      fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: rm.getAttribute('data-hv-remove'), quantity: 0 })
      }).then(function (r) { return r.json(); }).then(renderCart);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ---------- Add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-hv-add]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn && btn.getAttribute('data-in-cart') === 'true') { openDrawer(); return; }
    if (btn) btn.disabled = true;
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
      .then(function (res) {
        if (btn) btn.disabled = false;
        var msg = form.querySelector('[data-hv-error]');
        if (!res.ok) {
          if (msg) { msg.textContent = res.body.description || res.body.message || 'Kunne ikke lægge i kurven.'; msg.hidden = false; }
          return;
        }
        if (msg) msg.hidden = true;
        if (btn) {
          btn.textContent = btn.getAttribute('data-added-label') || 'I kurven ✓ – se kurv';
          btn.setAttribute('data-in-cart', 'true');
        }
        openDrawer();
      })
      .catch(function () { form.submit(); });
  });

  /* ---------- Product gallery ---------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-hv-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-hv-gallery]');
    var main = gallery.querySelector('[data-hv-main] img');
    if (main) {
      main.src = thumb.getAttribute('data-src');
      main.removeAttribute('srcset');
      main.alt = thumb.getAttribute('data-alt') || '';
    }
    gallery.querySelectorAll('[data-hv-thumb]').forEach(function (b) { b.classList.toggle('is-active', b === thumb); });
  });

  /* ---------- Variant select keeps the hidden id in sync ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-hv-variant]');
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex];
    var form = sel.closest('form');
    var btn = form.querySelector('[type="submit"]');
    if (btn) {
      var available = opt.getAttribute('data-available') === 'true';
      btn.disabled = !available;
      btn.textContent = available ? btn.getAttribute('data-label-prefix') + opt.getAttribute('data-price') : 'Udsolgt';
      btn.removeAttribute('data-in-cart');
    }
  });

  /* ---------- Calendar region filter ---------- */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-hv-region]');
    if (!chip) return;
    var cal = chip.closest('[data-hv-calendar]');
    var region = chip.getAttribute('data-hv-region');
    var shown = 0;
    cal.querySelectorAll('[data-hv-region]').forEach(function (c) {
      var on = c === chip;
      c.classList.toggle('is-active', on);
      c.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    cal.querySelectorAll('[data-region]').forEach(function (row) {
      var show = region === 'Alle' || row.getAttribute('data-region') === region;
      row.hidden = !show;
      if (show) shown++;
    });
    var empty = cal.querySelector('[data-hv-cal-empty]');
    if (empty) empty.hidden = shown > 0;
  });

  /* ---------- Collection sort ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-hv-sort]');
    if (!sel) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });
})();

/* Condition (tier) filter on product grids – filters the cards on the current page */
if (!window.HVTierFilter) {
window.HVTierFilter = true;
document.addEventListener('click', function (e) {
  var chip = e.target.closest('[data-hv-tier]');
  if (!chip) return;
  var main = chip.closest('[data-hv-shop]') || document;
  var tier = chip.getAttribute('data-hv-tier');
  var shown = 0;
  chip.parentNode.querySelectorAll('[data-hv-tier]').forEach(function (c) {
    var on = c === chip;
    c.classList.toggle('is-active', on);
    c.setAttribute('aria-pressed', on ? 'true' : 'false');
  });
  main.querySelectorAll('[data-hv-grid] .hv-card').forEach(function (card) {
    var show = tier === 'Alle' || card.getAttribute('data-tier') === tier;
    card.hidden = !show;
    if (show) shown++;
  });
  var empty = main.querySelector('[data-hv-grid-empty]');
  if (empty) empty.hidden = shown > 0;
});
}

/* Category strip: bring the active circle into view when the strip scrolls sideways (phones, tablets) */
if (!window.HVCatsScroll) {
  window.HVCatsScroll = true;
  var hvShowActiveCat = function () {
    document.querySelectorAll('.hv-cats').forEach(function (strip) {
      var active = strip.querySelector('.is-active');
      if (!active || strip.scrollWidth <= strip.clientWidth) return;
      var pad = parseFloat(getComputedStyle(strip).paddingLeft) || 0;
      strip.scrollLeft = active.offsetLeft - strip.offsetLeft - pad;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hvShowActiveCat);
  else hvShowActiveCat();
}
